import { Box, Button, Typography } from "@mui/material";
import * as React from "react";
import StudentFormNoSend from "../../views/Students/StudentFormNoSend";
import RepresentativeFormNoSend from "../Representatives/RepresentativeFormNoSend";
import {
  CourseType,
  RepresentativeFormType,
  StudentFormType,
} from "../../types/entitiesModel";
import CourseSelectFormNoSend from "../Course/CourseSelectFormNoSend";

const CreateStudent: React.FC = () => {
  const [formStateStudent, setFormStateStudent] =
    React.useState<StudentFormType>({
      name: "",
      document: "",
      email: "",
      phone: "",
      address: "",
      representative_id: 0,
      category_id: 0,
      imageString: ""
    });

  const [formStateRepresentative, setFormStateRepresentative] =
    React.useState<RepresentativeFormType>({
      name: "",
      document: "",
      relationship: "",
      phone: "",
      email: "",
    });

  const [selectionCourse, setSelectionCourse] =
    React.useState<CourseType | null>(null);

  const [repExists, setRepExists] = React.useState<boolean>(false);
  const [step, setStep] = React.useState<number>(1);

  const handleChangeFormStudent = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { name, value } = event.target;

    setFormStateStudent((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleChangeFormRepresentative = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { name, value } = event.target;

    setFormStateRepresentative((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleNextStep = () => {
    if (step < 2) {
      setStep(step + 1);
    }
  };

  const handlePreviousStep = () => {
    if (step > 1) {
      setStep(step - 1);
    }
  };

  return (
    <Box>
      {step === 1 && (
        <>
          <Box sx={{ paddingLeft: 2, mb: 2 }}>
            <Typography variant="h1">Información de inscripción</Typography>
          </Box>
          <Box>
            <CourseSelectFormNoSend
              selectionCourse={selectionCourse}
              setSelectionCourse={setSelectionCourse}
            />
          </Box>
          <Box>
            <StudentFormNoSend
              formState={formStateStudent}
              handleChangeForm={handleChangeFormStudent}
              setFormStateStudent={setFormStateStudent}
              repExists={repExists}
              setRepExists={setRepExists}
              showRepresentative={true}
            />
          </Box>
          <Box>
            <RepresentativeFormNoSend
              formState={formStateRepresentative}
              handleChangeForm={handleChangeFormRepresentative}
              setFormStateStudent={setFormStateRepresentative}
              repExists={repExists}
              setRepExists={setRepExists}
              importantAddRep={false}
              addPasswordField={false}
            />
          </Box>
        </>
      )}

      {step === 2 && (
        <>
          <Box>
            <Typography variant="h1">Información de Pago</Typography>
            {/* Other components to add */}
          </Box>
        </>
      )}

      {/* Botones de navegación */}
      <Box sx={{ mt: 2, display: "flex", justifyContent: "space-between" }}>
        <Button
          variant="outlined"
          onClick={handlePreviousStep}
          disabled={step === 1}
        >
          Anterior
        </Button>
        <Button variant="contained" onClick={handleNextStep}>
          {step === 1 ? "Siguiente" : "Confirmar"}
        </Button>
      </Box>
    </Box>
  );
};

export default CreateStudent;
